import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    boxShadow: '0px 6px 11px -11px rgba(0,0,0,0.75);',
    height: '80px',
    zIndex: '1000'
  },
  menuButton: {
    padding: '0 8px',
    width: 'max-content',
  },
  img: {
    height: 30,
    [theme.breakpoints.down('360')]: {
      height: 20,
    },
  },
  photo: {
    width: '30px',
    height: '30px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: '999px',
  },
  userLink: {
    textDecoration: 'none',
    color: 'inherit',
  },
  materialIcon: {
    marginRight: '10px',
  },
  container: {
    textAlign: 'left',
    marginLeft: '0',
    display: 'flex!important',
    maxWidth: '100%!important',
    '& > a': {
      textTransform: 'uppercase',
      display: 'flex',
      fontWeight: '500',

      '& svg': {
        marginRight: 4,
      },
    },
    [theme.breakpoints.down('1500')]: {
      display: 'none!important'
    },
  },
  drawer: {
    textDecoration: 'none',
    color: '#2196f3',
    marginRight: 25,
  },

  burger: {
    [theme.breakpoints.up('1500')]: {
      display: 'none'
    },
  },
  title: {
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    '& > img' : {
      [theme.breakpoints.down('470')]: {
        display: 'none'
      },
    }
  },
  truncate: {
    overflow: 'hidden', 
    textOverflow: 'ellipsis', 
    whiteSpace: 'nowrap', 
    maxWidth: 125
  }
}))
